/*
 *
 * SetPassword reducer
 *
 */

import { fromJS } from 'immutable';
import {
  DEFAULT_ACTION,
  UPDATE_PASSWORD_SUCCESS,
} from './constants';

const initialState = fromJS({ isLoading: false, update_res: {} });

function setPassowrdReducer(state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case DEFAULT_ACTION:
      return state.set('isLoading', payload);
    case UPDATE_PASSWORD_SUCCESS:
      return state
        .set('update_res', fromJS(action.payload));
    default:
      return state;
  }
}

export default setPassowrdReducer;



// WEBPACK FOOTER //
// client/containers/EmailVerification/reducer.js